import { Group, Text, Box } from '@mantine/core';
import { Link } from 'react-router-dom';
import { TERMS_OF_USE_URL, PRIVACY_POLICY_URL } from 'src/constants';
import { AprioriLogoPlain } from 'src/assets';

export function LayoutFooter() {
  return (
    <Group h="100%" justify="space-between">
      <Box w={220}>
        <AprioriLogoPlain className="h-8" />
      </Box>

      <Group gap={36}>
        <Link target="_blank" to={TERMS_OF_USE_URL}>
          <Text c="#E8E8E8">Terms of Service</Text>
        </Link>
        <Link target="_blank" to={PRIVACY_POLICY_URL}>
          <Text c="#E8E8E8">Privacy Policy</Text>
        </Link>
      </Group>
    </Group>
  );
}
